import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import * as echarts from "echarts";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useStore } from "vuex";
import { defineComponent, onMounted, reactive, ref, onUnmounted } from "vue";
import staticData from "@/assets/data/dataScreen.json";
export default defineComponent({
  name: "MissionIndex",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var store = useStore();
    var seriesArr = ref([]);
    var Data = reactive({
      option: {
        color: ["#0bd1fa", "#983eff"],
        legend: {
          show: false
        },
        tooltip: {
          trigger: "item",
          formatter: "分段 : {b}<br>占比 : {c}%"
        },
        series: seriesArr
      },
      tableData: []
    });
    onMounted(function () {
      if (store.state.system.demonstration) {
        Data.tableData = staticData.partyStatistics;
        setDataToTable();
        getMountEcherts();
      } else {
        getList();
        taskGetStatistics();
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getStatisticsDataScreen();

              case 2:
                _context.next = 4;
                return getMountEcherts();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();

    var timer;

    var taskGetStatistics = function taskGetStatistics() {
      timer = setInterval(function () {
        getStatisticsDataScreen(); // clearInterval(timer);
        // taskGetStatistics();
      }, 10000);
    };

    onUnmounted(function () {
      clearInterval(timer);
    });

    var getStatisticsDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getStatisticsDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.tableData = res.data;
                  setDataToTable();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getStatisticsDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //向框架里添加数据


    function setDataToTable() {
      Data.tableData.forEach(function (item, index) {
        seriesArr.value.push({
          name: "",
          type: "pie",
          radius: "52%",
          center: [index * 33 + 17 + "%", "43%"],
          label: {
            normal: {
              formatter: "{a|{b}}\n{per|{d}%}",
              position: "outer",
              alignTo: "labelLine",
              overflow: "none",
              minAngle: 40,
              avoidLabelOverlap: true,
              rich: {
                a: {
                  fontSize: 14,
                  color: "#4dbdff",
                  lineHeight: 12,
                  padding: [5, 0, 0, 0],
                  align: "top",
                  position: "outer"
                },
                per: {
                  color: "#ffffff",
                  fontSize: 13,
                  align: "top",
                  padding: [5, 0, 0, 0],
                  lineHeight: 12,
                  position: "outer"
                }
              }
            }
          },
          data: [{
            label: {
              show: false
            },
            value: item.dataValue[1].value
          }, {
            value: item.dataValue[0].value
          }]
        });
      });
    } //挂载eCharts


    var myChartRef = ref();
    var myChartPartyStatistic;

    var getMountEcherts = function getMountEcherts() {
      myChartRef.value = document.getElementById("partyMain");

      if (myChartRef.value) {
        myChartPartyStatistic = echarts.init(myChartRef.value);
        myChartPartyStatistic.setOption(Data.option);
      }
    };

    var initPartyStatistics = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                myChartPartyStatistic.resize();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function initPartyStatistics() {
        return _ref3.apply(this, arguments);
      };
    }();

    window.addEventListener('resize', function () {
      myChartPartyStatistic.resize();
    });
    return {
      Data: Data,
      initPartyStatistics: initPartyStatistics,
      seriesArr: seriesArr,
      getMountEcherts: getMountEcherts,
      getList: getList,
      getStatisticsDataScreen: getStatisticsDataScreen,
      setDataToTable: setDataToTable
    };
  }
});